import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parseArray',
  pure: false
})
export class ParseArrayPipe implements PipeTransform {

  transform(value: string): string[] {
    return value.split(',');
  }
}
